module.exports = __webpack_public_path__ + "static/media/error-400-flags.da9d1fd6.png";